export default __webpack_public_path__ + "static/media/ico_bin.7af20b3d.svg";